import { FunctionComponent } from "react";

import { ModulePermissionQuery } from "src/app/modules/user_and_permissions/models/Permission.model";

export enum RewardType {
  'e-voucher' = 'DIGITAL',
  'physical-voucher' = 'FISIK',
  'free-parking' = 'PARKING',
  'birthday-gift' = 'BIRTHDAY',
  'featured-rewards' = 'REWARDS',
  'exhibition' = 'TICKET',
  'voucher-group' = 'VOUCHER_GROUP',
  'session' = 'SESSION',
  'event' = 'TICKET'
}

export type RewardValue = 'DIGITAL' | 'FISIK' | 'PARKING' | 'BIRTHDAY' | 'REWARDS' | 'VOUCHER_GROUP' | 'TICKET' | 'SESSION' | 'EVENT';

export type RewardPathType = keyof typeof RewardType;

export interface TabModel {
  component: FunctionComponent<any>;
  permission: ModulePermissionQuery;
  value: RewardValue;
  label: string;
  path: RewardPathType;
}
